import { createSlice } from "@reduxjs/toolkit";
const locationSlice = createSlice({
    name: "location",
    initialState: {
        // address: "Sahibzada Ajit Singh Nagar, Punjab, India",
        // coords: { lat: 30.7046486, lng: 76.71787259999999 }
    },
    reducers: {
        addLocation(state, action) {
            return state = action.payload;
        },
        updateLocation(state, action) {
            state = { ...state, ...action.payload }
        },
        clearLocation(state, action) {
            return state = {}
        }
    },
});
export const { addLocation, updateLocation, clearLocation } = locationSlice.actions;
export default locationSlice.reducer;